import { AlertTriangle } from "lucide-react";
import { Button } from "@stackje/shared-components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@stackje/shared-components/ui/dialog";

interface UnsavedChangesConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export function UnsavedChangesConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  title = "Unsaved Changes",
  description = "You have unsaved changes. Are you sure you want to close without saving?",
  confirmLabel = "Discard Changes",
  cancelLabel = "Keep Editing",
}: UnsavedChangesConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader className="flex flex-col items-center gap-2">
          <AlertTriangle className="h-12 w-12 text-red-500" />
          <DialogTitle className="text-xl">{title}</DialogTitle>
          <DialogDescription className="text-center text-base">
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:flex-row sm:justify-center gap-2">
          <Button
            variant="outline"
            onClick={onCancel}
            className="sm:w-32"
          >
            {cancelLabel}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            className="sm:w-32"
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}